<template>
  <div class="go-a">
    <!-- <van-overlay :show="isLoading">
      <div class="wrapper">
        <van-loading type="spinner" />
      </div>
    </van-overlay> -->
     <van-sticky>
      <header class="index-index-header">
      <div class="index-bees-adds">
        <div v-if="!miniApp" class="go-l"><van-icon name="arrow-left" size="24" @click="goback" /></div>
        <van-field
          v-model="value"
          class="go1-1"
          placeholder="请输入搜索关键词">
          <template #left-icon>
            <img class="ix licon" src="@/assets/image/brand-search-icon.png">
          </template>
          <template #right-icon>
            <img class="ix ricon" src="@/assets/image/filter-picker-close@2x.png" @click="()=>{value = ''}">
          </template>
        </van-field>
        
        <div class="button" @click="onSearch">搜索</div>
        <!-- <div class="go1-2" @click="gocarFun"><van-icon name="shopping-cart-o" size="20" :badge="carNum" /></div> -->
      </div>
      <van-sticky v-if="$route.query.branchId">
        <div class="index-manjian">
          <div class="div1">
            <div class="div1_1">以下商品可享受：</div>
            <div class="div1_2">
              <van-count-down :time="time" :auto-start="runTime" format="仅剩 HH 时 mm 分">
                <template v-if="runTime" #default="timeData"><div class="tex2">仅剩<span v-show="timeData.days > 0" class="time">{{ timeData.days }}</span><span v-show="timeData.days > 0">天</span><span class="time">{{ timeData.hours }}</span>时<span class="time">{{ timeData.minutes }}</span>分</div></template>
                <template v-if="!runTime"><div class="tex2">结束时间：{{endTime}}</div></template>
              </van-count-down>
            </div>
          </div>
          <div class="div2">
            <div class="iconbt" v-for="(item,index) in zheList" :key="index">{{item}}</div>
            <div style="clear: both;"></div>
          </div>
        </div>
      </van-sticky>
      </header>
     
    <div :class="['go2', {'act':$route.query.activityId}]" v-show="couponDesc">{{couponDesc}}</div>
    
       <FilterItem
      v-if="$route.query.couponId"
      class="filter-item"
      :onFixed="false"
      :display="display"
      @onClick="onFilterItemClick"
    />
    </van-sticky> 
   
    <div class="go3">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="isLoading"
          :finished="finished"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          finished-text="没有更多数据"
          offset="700"
          @load="onLoad"
        >
        <div 
          v-if="list.length > 0"
          class="container-water-fall"
        >
          <Waterfall
            :minCol="2"
            :maxCol="2"
            :percent="[1,1]"
            :width="itemWidth"
            :gutterWidth="gutterWidth"
          >
            <div :class="['go3-0', {'go3-0-0': $route.query.activityId}]"  v-for="(item,index) in list" :key="index">
              <div class="go3-1">
                <img v-lazy="setImgStyle(item)" fit="contain" class="index-title-image" lazy-progressive :style="{ height: pxToRem(item)}"  @click="goCommoditydetails(item.id)"/>
                <div class="go3-2">
                  <p class="go3-2-1">{{item.itemName}}</p>
                  <div class="go3-2-2">
                    <div class="go3-2-2-1">
                    ￥{{item.price}}
                    <span v-if="item.estimatePriceTag" :style="{'color':item.labelTextColor,'background-color':item.labelColor}">{{item.estimatePriceTag}}</span>
                    </div>
                    <div class="go3-2-2-3" v-if="(item.markingPrice && item.price <= item.markingPrice)  || (item.markingPrice && hideTenant.includes(tenantCode))">￥<i>{{item.markingPrice}}</i>
                    <span v-if="(item.discount && item.price <= item.markingPrice) || (item.discount && hideTenant.includes(tenantCode))"> {{item.discount}}</span>
                    </div>
                  </div>
                  <div class="dsct" v-if="item.discountInfo">{{item.discountInfo}}</div>
                </div>
              </div>
            </div>
          </Waterfall>
        </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-action-sheet v-model="openvisible">
      <div class="content">
        <header class="header">
          <van-image
            width="90"
            height="90"
            :src="attrs.imageInfo+'?x-oss-process=style/style_detail_select_img'"
          ></van-image>
          <div class="sku_info">
            <p class="sku_price">
              ￥{{attrs.salePrice}}
            </p>
            <p class="sku_sum">库存{{attrs.stock}}件</p>
            <p class="sku_chekc">已选{{attrs.attributeName}}</p>
          </div>
        </header>
        <div class="suk_attribute">
          <div
            class="attribute_item"
            v-for="(item,index) in commoditys.goodAttributeDTOList "
            :key="index"
          >
            <span class="attribute_title">{{item.attributeName}}</span>
            <div class="attribute_text">
              <span
                v-for="(i,idx) in item.attributeValues"
                :key="idx"
                :class="{'active':i.id==queryData[item.attributeName]}"
                @click="onAttrClick(i.id, item.attributeName, commoditys.id)"
              >{{i.attributeValue}}</span>
            </div>
          </div>
        </div>
        <div class="stepper van-hairline--top">
          <p>购买数量</p>
          <van-stepper
            v-model="stepperValue"
            min="1"
            :max="attrs.stock"
            integer
            button-size="20px"
          />
        </div>
        <footer class="footer">
          <button
            class="shoppingCart van-goods-action-button--warning"
            @click="addCart(commoditys.id)"
            :disabled="attrs.stock==0"
          >加入购物车</button>
        </footer>
      </div>
    </van-action-sheet>
    <img
      class="scroll-to-top"
      v-show="scrollLength > 20"
      src="@/assets/image/return_scrolltop@2x.png"
      @click="scrollToTop"
    />
    <img 
      class="go-car-top" 
      src="@/assets/image/carva.png"
      @click="gocarFun"
    />
    
  </div>
</template>
<script>
import http from "@/utils/axios";
import utils from "@/utils/common";
import FilterItem from '@/components/filter/item';
import moment from 'moment'; 
import { Waterfall } from "vue2-waterfall";
export default {
  components: { FilterItem,Waterfall },
  data() {
    return {
      hideTenant:['5ox02w','ldu14z'],
      tenantCode:this.$route.query.tenant_code || '75c8dm',
      minimumAmount: this.$route.query.minimumAmount || "-",
      couponValue: this.$route.query.couponValue || "-",
      goodTypeDesc: this.$route.query.goodTypeDesc || "",
      error: false,
      refreshing: false,
      isLoading: false,
      finished: false,
      value: "",
      list:[
            // {
            //     "auditMode":1,
            //     "auditTime":"2022-06-23 09:31:22",
            //     "autoLoadTimeStatus":1,
            //     "autoLoadType":1,
            //     "autoUnloadTimeStatus":1,
            //     "branchNo":341,
            //     "categoryId":118,
            //     "checkStatus":"FINISH",
            //     "creator":"BRANCH:14986",
            //     "delayedAuditStatus":1,
            //     "discountInfo":"5件折上7折",
            //     "estimatePriceTag":"到手价",
            //     "firstCommit":2,
            //     "frightId":199,
            //     "gmtCreated":"2022-04-08 10:00:24",
            //     "gmtModified":"2022-07-18 16:34:17",
            //     "goodsCode":"",
            //     "goodsDetailType":2,
            //     "honey":0,
            //     "id":741729,
            //     "imageUrlsKey":"publicoss:uploadfile/2022/4/8/16493831989962591521732607045.jpeg",
            //     "indexImageKey":"https://img-test.chinabeego.com/uploadfile/2022/4/8/16493831602972591483033164548.png",
            //     "isDeleted":"n",
            //     "isHot":"n",
            //     "isQuick":"n",
            //     "isVirtual":"n",
            //     "itemName":"折上折按件数打折",
            //     "levelFourCategoryId":50803,
            //     "lowerShiefDate":"2022-06-23 09:31:22",
            //     "markingPrice":3,
            //     "memberPrice":0,
            //     "modifier":"BRANCH:14986",
            //     "price":1.62,
            //     "shopId":77,
            //     "supplierChannel":0,
            //     "top":1,
            //     "upShelf":"y",
            //     "upperShiefDate":"2022-07-18 16:34:16",
            //     "weight":0.1
            // }
        ],
      pageNum: 1,
      pageSize: 10,
      openvisible: false,

      item: {},
      attrs: {},
      commoditys: {},
      current: 0,
      isquick: "n",
      imageLength: 3,
      sku: {},
      imags: "",
      commodityId: "",
      stepperValue: 1,
      queryData: {},
      attrsValues: [],
      stockData: {},
      carNum: 0,
      miniApp: false,
      sort: true,
      branchNo:[],
      couponDesc:"",
      minPrice: '',
      maxPrice: '',
      display: {one: { show: false }, two: { show: false }, three: { name: '价格', showIcon: true, actived: false, key: 'up' }, four: { active: false, name: '品牌筛选' }},
      zheList:[],
      runTime: true, //默认倒计时开启
      time:0,
      endTime:'',
      scroll: "",
      scrollLength: "",
    };
  },
  mounted(){
    window.addEventListener("scroll", this.gundong, true);
  },
  methods: {
	  // 懒加载
	  setImgStyle(item) {
	    if (item.indexImageKey) {
	      return item.indexImageKey + "?x-oss-process=style/style_index_list_img";
	    } 
	  },
    // 滚动事件
    gundong(e) {
      this.scroll = e.target;
      this.scrollLength = e.target.scrollTop;
    },
    scrollToTop(){
      this.scroll.scrollTop = 0
    },
    pxToRem(item) {
      if (item.picHeight > 1000) {
        return (Number(item.picHeight) / 500) * 0.01333 + "rem";
      } else if (item.picHeight > 500) {
        return (Number(item.picHeight) / 100) * 0.01333 + "rem";
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.pageNum = 1;
        this.list= [];
        //恢复不是最后一页
        this.refreshing = false;
        this.onLoad();
      }, 1000);
    },
    onLoad(tab) {
      this.isLoading = true;
      if(this.$route.query.couponId) {
        this.getCouponWidthGoodsList();
      } else {
        this.getActWidthGoodsList()
      }
    },
    getCouponWidthGoodsList() {
      http({
        url: "order/coupon/getCouponGoods",
        method: "post",
        parmes: {
          "branchNo": 0,
          "brandIdList": this.brandIdList || [],
          "categoryIdList": this.categoryIdList || [],
          "couponId": this.$route.query.couponId,
          "discountSort": "",
          "minPrice": this.minPrice,
          "maxPrice": this.maxPrice,
          "goodName": this.value,
          "pageIndex": this.pageNum,
          "pageSize": this.pageSize,
          "sort": this.sort ? 1:2
        }
      })
        .then(rps => {
          if (rps.code === 200) {
            this.couponDesc = rps.couponDesc;
            this.$loading.hide();
            this.error = false;
            //最后一页
            if (rps.data.pages == 0 || rps.data.list.length === 0) {
              this.finished = true;
            } else {
              this.finished = false;
              this.pageNum == 1 && (this.list.splice(0, this.list.length));
              this.list = this.pageNum == 1 ? rps.data.list : this.list.concat(rps.data.list);
              this.pageNum++;
            }
            this.isLoading = false;
          }
        })
        .catch(rps => {
          this.error = true;
          this.$loading.hide();
        });
    },
    getActWidthGoodsList() {
      http({
        url: "order/app/discount/canSelectGoods",
        method: "post",
        parmes: {
          "branchId": this.$route.query.branchId || '',
          "activityId": this.$route.query.activityId || '',
          "goodName": this.value,
          "pageIndex": this.pageNum,
          "pageSize": this.pageSize
        }
      })
        .then(rps => {
          if (rps.code === 200) {
            this.couponDesc = rps.discountDesc;
            rps.endTime && this.countTimeFun(rps.endTime);
            this.zheList = rps.discountStr && rps.discountStr.split(',') || [];
            this.$loading.hide();
            this.error = false;
            if (rps.data.pages == 0 || rps.data.list.length === 0) {
              this.finished = true;
            } else {
              this.finished = false;
              this.pageNum == 1 && (this.list.splice(0, this.list.length));
              this.list = this.pageNum == 1 ? rps.data.list : this.list.concat(rps.data.list);
              this.pageNum++;
            }
            this.isLoading = false;
          }
        })
        .catch(rps => {
          this.error = true;
          this.$loading.hide();
        });
    },
    onSearch() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.list = [];
      this.onLoad();
    },
    // 属性点击事件
    onAttrClick(value, key, goodId) {
      if (value && key) {
        let parmes = {};
        parmes[key] = value;
        this.$set(this.queryData, key, value);
        // this.queryData = Object.assign({}, this.queryData, parmes);
        // console.log(this.queryData);
        this.setSKU(this.queryData);
        // console.log(this.attributeValueIds);
      }
      if (
        this.attributeValueIds.length !==
        this.commoditys.goodAttributeDTOList.length
      ) {
        return;
      }
      // let ids=[];
      // this.attributeValueIds.forEach(item=>{
      //   if(item >0){
      //   ids.push(item)
      //   }
      // })
      http({
        url: "item/app/item/find/stockValues",
        method: "post",
        parmes: {
          goodId: goodId,
          attributeValue: this.attributeValueIds
        }
      }).then(rps => {
        if (rps.code === 200) {
          this.attrs = {
            salePrice: rps.data.salePrice,
            stock: rps.data.stock,
            imageInfo: rps.data.imageInfo && rps.data.imageInfo.imageUrl,
            attributeName: rps.data.attributeValueName,
            skuId: rps.data.id
          };
          if (rps.data.isSellOut === "y") {
            this.attrs.salePrice = "无货";
            this.stock = 0;
          }
          this.stockData = rps.data;
        }
      });
    },
    //  获取详情,加入购物车需要的参数
    openvisibleFun(goodsId) {
      this.isLoading = true;
      http({
        url: "item/app/item/" + goodsId,
        method: "get"
      }).then(rps => {
        this.isLoading = false;
        this.isquick = rps.data.isQuick;
        this.commoditys = rps.data;
        this.isfollw = rps.data.isFollow;
        this.attributeValueIds = rps.data.attribute.attributeValueIds;
        this.attrs.attributeName = rps.data.attribute.attributeValueName;
        let arr = rps.data.attribute.attributeValueIds.reverse();
        rps.data.goodAttributeDTOList.forEach((i, idx) => {
          let params = {};
          params[i.attributeName] = arr[idx];
          this.queryData = Object.assign({}, this.queryData, params);
        });
        if (
          this.attributeValueIds.length != rps.data.goodAttributeDTOList.length
        ) {
          this.attributeValueIds.push(-1);
        }
        this.onAttrClick("", "", rps.data.id);
        let imgs = [];
        this.commoditys.image1s.forEach(item => {
          imgs.push(item.imageUrl);
        });
        this.imags = imgs;
        this.imageLength = this.commoditys.image1s.length;
        this.isDisable = rps.data.isDisable;

        this.openvisible = true;
      });
    },
    // 添加购物车
    addCart(goodId) {
      if (this.stepperValue > this.attrs.stock) {
        return this.$toast("该商品库存不够");
      }
      if (this.attrs.stock === 0) {
        return this.$toast("该商品暂无库存");
      }
      http({
        url: "item/shoppingCart/add",
        method: "post",
        parmes: {
          goodId: goodId,
          count: this.stepperValue,
          skuId: this.attrs.skuId
        }
      }).then(rps => {
        if (rps.code === 200) {
          this.$toast({
            message: "添加购物车成功",
            icon: "cart-o"
          });
          this.getCarNum();
          this.openvisible = false;
        } else {
          this.$toast(rps.message);
        }
      });
    },
    async setSKU(parmes) {
      this.attributeValueIds = [];
      return new Promise((resolve, reject) => {
        for (let i in parmes) {
          if (i !== "undefined" || i !== null) {
            this.attributeValueIds.push(parmes[i]);
          }
        }
        resolve(true);
      });
    },
    gocarFun() {
      if (window.tools.isWechat()) {
        wx.miniProgram.switchTab({
          url: "/pages/tabbar-mycart/index"
        });
      } else {
        utils.goPageByName({
          id: "shopcart",
          name: "购物车"
        });
      }
    },
    
    //购物车数量
    getCarNum() {
      http({
        url: "item/shoppingCart/queryCount",
        method: "get"
      }).then(rps => {
        this.carNum = rps.data;
      });
    },
    goback() {
      utils.goBack();
    },
    goCommoditydetails(id) {
      if (this.miniApp) {
        wx.miniProgram.navigateTo({
          url: "/product/pages/product-detail/index?productid=" + id
        });
      } else {
        // this.$router.push({ path: "/commoditydetails", query: { id: id } });
        var obj = {goodsId:parseInt(id)};
        utils.jumpToNewPage({
          url: location.origin + "/h5user/commoditydetails?id=" + id,
          noTitle: "0",
          action:{tm:"4030100",tp:obj}
        });
      }
    },
    onFilterItemClick({ type, sort }){
      if(type == 'four') {
        this.$filterDrawer({
          visiblePriceInput: false,
          list: [{
            type: 'input',
            alias: 'price'
          },{
            type: 'category',
            alias: 'categories',
            idKey: 'id',
            valueKey: 'categoryName',
            childKey: 'children',
            data: this.categoryData
          },{
            type: 'other',
            alias: 'logos',
            idKey: 'brandId',
            valueKey: 'brandName',
            data: this.logosData
          }],
          confirm: res => {
            this.minPrice = res.minPrice
            this.maxPrice = res.maxPrice
            this.categoryIdList = res.categories
            this.brandIdList = res.logos
            this.display.four.active = res.state
            this.list = [];
            this.pageNum = 1;
            this.onLoad();
          }
        })
      } else {
        if(this.isLoading) return;
        this.sort = !this.sort;
        this.list= [];
        this.pageNum = 1;
        this.onLoad();
      }
    },
    getLogosData() {
      http({
        url: "order/coupon/getCouponGoodsBrand",
        method: "POST",
        parmes: {
          "couponId": this.$route.query.couponId,
          "pageIndex": 1,
          "pageSize": 10
        }
      }).then(res => {
        this.logosData = res.data
      });
    },
    getCategoryData() {
      http({
        url: "order/coupon/getCouponGoodsCategory",
        method: "POST",
        parmes: {
          "couponId": this.$route.query.couponId,
          "pageIndex": 1,
          "pageSize": 10
        }
      }).then(res => {
        this.categoryData = res.data
      });
    },
    countTimeFun(haomiao){
      //86400000 一天的毫秒数
      let timestamp=new Date().getTime();
      if((haomiao - timestamp) <= (3 * 86400000)){
        this.runTime = true;
        this.time= haomiao - timestamp
      }else{
        this.runTime = false; //不开启倒计时
        this.endTime = moment(haomiao).format('YYYY-MM-DD HH:mm')
      }
    }
  },
  created() {
    this.miniApp = window.tools.isWechat();
    // this.getCarNum();
    if(this.$route.query.couponId) {
      this.getLogosData()
      this.getCategoryData()
    }
  },
  computed: {
    itemWidth() {
      return 133 * 0.5 * (document.documentElement.clientWidth / 375);
    },
    gutterWidth() {
      return 10 * 0.5 * (document.documentElement.clientWidth / 375);
    }
  },
};
</script>
<style lang="less" scoped>
.container-water-fall {
  padding: 20px 0px 0px 20px;

  width: 100vw;
  box-sizing: border-box;
}
.index-title-image{
  width: 100%;
  min-height: 320px;
  max-height: 600px;
  border-top-left-radius:10px;
  border-top-right-radius:10px;
  overflow: hidden;
  object-fit: cover;
}
.index-title-image[lazy=loaded]{
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.go-a {
  background-color: #fff;
}
.filter-item /deep/.item-box {
  padding-left: 30px;
  padding-right: 20px;
  .item:first-child {
    text-align: left;
  }
  .item:last-child {
    text-align: right;
  }
}
.index-index-header{
  background-color: white;
  .index-bees-adds{
    height: 89px;
    display: flex;
    align-items: center;
    padding: 0 30px;
  }
  .index-manjian{
    font-size: 22px;
    background-color: #ffffff;
    padding: 20px 30px 10px 30px;
    .div1{
      display: flex;
      justify-content: space-between;
      align-items:center;
      margin-bottom: 21px;
      
      .div1_1{
        color: #333333;
      }
      .div1_2{
        color: #F8A651;
        display: flex;
        .van-count-down{
          color: #F8A651;
        }
        .time{
          border-radius: 10px;
          border: 1PX solid #F8A651;
          font-size: 22px;
          padding: 1px 11px 0 11px;
          margin-left: 5px;
          margin-right: 5px;
          
        }
        .tex2{
          font-size: 22px !important;
        }
      }
    }
    .div2{
      clear: both;
      .iconbt{
        color: #ED3939;
        background: #FFEDEE;
        border-radius: 10px;
        padding:2px 11px;
        margin-right: 10px;
        margin-bottom: 10px;
        float:left;
      }
    }
  }
  .go-l{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 76px;
    height: 76px;
  }
  .go1-1{
    flex: 1;
    padding: 0;
    background-color: #F7F7F7;
    border: 0px;
    border-radius: 38px;
    .ix{
      width: 40px;
      height: 40px;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .licon{
      margin-left: 10px;
    }
    .ricon{
      margin-right: 10px;
    }
  }
  .van-cell{
    line-height: 0;
  }
  .button{
	background-color: var(--buttonColor);
  color: var(--textColor);
	width: 140px;
	margin: 0 0 0 20px;
	height: 60px;
	line-height: 60px;
    border-radius: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    // padding: 0 30px;
  }
  .go1-2{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 27px;
  }
}
.go2 {
  text-align: center;
  background-color: #F7F7F7;
  color: #333;
  height: 85px;
  line-height: 85px;
  font-size: 24px;
  font-weight: bold;
}
.go2.act {
  background-color: #FFE7E6;
  color: #ED3939;
}
.pageIndex {
  overflow: hidden;
  .pageIndex-1 {
    // border: 1px solid red;
    overflow: hidden;
  }
  .pageIndex-1 > li {
    overflow: hidden;
    display: inline-block;
    margin-right: 18px;
  }
  .pageIndex-1 > li:nth-child(even) {
    display: inline-block;
    margin-right: 0;
  }
}

.go3-0{
	border-radius: 20px!important;
}
.go3 {
  font-size: 26px;
  background-color: #f7f7f7;
  .go3-0.go3-0-0 {
    // height: 614px
  }
  .go3-0 {
	margin-bottom: 20px;
	border-radius: 20px!important;
    .go3-1 {
      margin-right: 20px;
    }
    .go3-2 {
      padding: 20px;
      // border: 1px solid #f2f2f2;
      margin-top: -10px;
      border-top: 0;
      background-color: #fff;
	  border-bottom-right-radius:20px;
	  border-bottom-left-radius:20px;
      .go3-2-1 {
        margin-bottom: 18px;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .go3-2-2 {
        display: flex;
        // align-items: center;
        flex-direction: column;
        align-items: flex-start;
        // justify-content: flex-start;
        .go3-2-2-1 {
          font-size: 26px;
          color: #e83636;
          font-weight: bolder;
          span {
            background: #FFEDEE;
            border-radius: 10px;
            font-size: 22px;
            font-weight: 400;
            color: #ED3939;
            line-height: 30px;
            padding: 0 10px;
            margin-left: 10px;
          }
        }
        .go3-2-2-3{
          color: #cccccc;
          font-size: 22px;
          // padding-left: 30px;
          // text-decoration:line-through;
          i {
          text-decoration:line-through;
          font-style: normal;

          }
          span {
            text-decoration:none !important;
            background: #FFEDEE;
            border-radius: 10px;
            font-size: 22px;
            font-weight: 400;
            color: #ED3939;
            line-height: 30px;
            padding: 0 10px;
            margin-left: 10px;
          }
        }
        .go3-2-2-2 {
          text-align: right;
          width: 50%;
        }
      }
    }
  }
}
// 购物车弹窗
.content {
  padding: 20px 30px;
  position: relative;
  .header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 40px;
    .sku_info {
      padding-left: 30px;
      .sku_price {
        color: #ff1c1c;
        font-size: 36px;
        .size24 {
          font-size: 24px;
        }
      }
      .sku_sum {
        font-size: 24px;
        color: #ccc;
        padding: 10px 0;
      }
      .sku_chekc {
        font-size: 24px;
        color: #333;
        font-weight: 400;
      }
    }
  }
  .suk_attribute {
    padding-top: 80px;
    .attribute_title {
      font-size: 26px;
      color: #333;
      font-weight: 500;
      padding-bottom: 30px;
    }
    .active {
      background: #f8d543 !important;
    }
    .attribute_text {
      display: flex;
      flex-wrap: wrap;
      span {
        display: inline-block;
        min-width: 70px;
        font-size: 24px;
        padding: 10px 20px;
        border: 1px solid #f2f2f2;
        border-radius: 40px;
        margin: 10px;
        text-align: center;
        background: #f1f1f1;
      }
    }
  }
  .stepper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 400;
    font-size: 24px;
    padding: 40px 0;
    color: #333;
    /deep/ .van-stepper__minus {
      border-radius: 50%;
      background-color: #f8d541;
    }
    /deep/ .van-stepper__plus {
      border-radius: 50%;
      background-color: #f8d541;
    }
    /deep/ .van-stepper__input {
      background: none !important;
    }
    /deep/ .van-stepper__minus--disabled,
    /deep/ .van-stepper__plus--disabled {
      background-color: #f7f8fa;
    }
  }
  .footer {
    font-size: 24px;
    bottom: 10px;
    width: 100%;
    text-align: center;
    .shoppingCart {
      font-size: 24px;
      color: #333333;
      background: #f8d541;
      border-radius: 39px;
      width: 520px;
      height: 78px;
    }
    button {
      border: 0;
    }
  }
}
.search_index {
  position: relative;
  background: #fff;
  /deep/.van-search__content--round {
    border-radius: 100px;
  }
  /deep/.van-cell {
    padding: 14px;
  }
  .item {
    width: 100%;
  }
  .search-text {
    position: absolute;
    right: 0;
    font-size: 20px;
    width: 100px;
    height: 38px;
    line-height: 38px;
    top: 0;
    margin-top: 25px;
    text-align: center;
    color: #999999;
  }
}
.img1{
  max-width: 336px;
  max-height: 396px;
  border:0;
  vertical-align: middle;
  margin: 0 auto;
}
.dsct {
  display: inline-block;
  width: fit-content;
  border-radius: 10px;
  font-size: 20px;
  // background-color: #FFE7E6;
  color: #ED3939;
  padding: 0 10px;
  margin-top: 10px;
  border: 1px solid #ED3939;
  line-height: 30px;
}
.go-car-top {
  position: fixed;
  right: 20px;
  bottom: 80px;
  z-index: 60;
  width: 120px;
  height: 120px;
}
.scroll-to-top{
  position: fixed;
  right: 20px;
  bottom: 200px;
  z-index: 60;
  width: 120px;
  height: 120px;
}
</style>
